import { Link } from 'react-router-dom';
import { CURRENCY } from '@voladeum/client';
import { Pair } from 'client/voladeum/pairs/types';
import { useGridColumnContext } from 'framework/Grid/context/GridColumnContext';
import { useGridRowContext } from 'framework/Grid/context/GridRowContext';

import { CRYPTO_PATH } from '../../constants';

import cn from './Cell.module.scss';

const { PUBLIC_URL } = process.env;

export const GridPairCell = () => {
  const { row } = useGridRowContext<Pair>();
  const { column } = useGridColumnContext();

  return (
    <Link
      className={cn.cell}
      to={`/application/pairs/${row.pair_id}`}
      style={{ justifyContent: column.text_align }}
    >
      <img
        src={`${PUBLIC_URL}/cryptocurrencies/${CRYPTO_PATH[row.base_currency_id as CURRENCY]}.svg`}
        alt={row.base_currency_name}
      />
      <div className={cn.stacked}>
        <span>{row.pair_name}</span>
        <span className={cn.small}>{row.base_currency_name}</span>
      </div>
    </Link>
  );
};
